import React, {useEffect, useState} from 'react';
import '../../css/web/AdminInflowStatusPg.css';
import axios from '../../services/axiosInstance';
import maCateImg from "../../assets/img/m-a-cate.png";
import ApexCharts from "react-apexcharts";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";

function AdminAdInflowPg() {

    /** region DataTable */

    const [searchData, setSearchData] = useState([]);
    const [socialData, setSocialData] = useState([]);
    const [deviceData, setDeviceData] = useState([]);

    /** endregion */

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const startHandle = (e) => { setStartDate(e.target.value); };
    const endHandle = (e) => { setEndDate(e.target.value); };

    useEffect(() => {
        const today = new Date();
        // 한국시간 기준으로 날짜 설정
        const kstToday = new Date(today.toLocaleString("en-US", { timeZone: "Asia/Seoul" }));
        const formatDateString = (date) => {
            if (!date) return '';
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`; // yyyymmdd
        };
        const formatted = formatDateString(kstToday);
        setStartDate(formatted);
        setEndDate(formatted);
    }, []);

    const [adData, setAdData] = useState([]);
    const selectedAllAdDataByDate = () => {
        axios({
            method: 'post',
            url: '/channelLog/selectedAllAdDataByDate',
            params: {
                startDate: startDate,
                endDate: endDate,
            }
        }).then((res) => {
            setAdData(res.data);
        }).catch((err) => {
            console.log("All AdData selected Fail : ", err)
        })
    }

    const getCount = (eventType, channelType) => {
        return adData.filter(item => item.eventType === eventType && item.channelType === channelType).length;
    };
    const getJoinTotalLength = () => {
        return adData.filter(item => item.eventType === '2').length;
    };
    const getPurchaseTotalLength = () => {
        return adData.filter(item => item.eventType === '1').length;
    };
    const getPlatformCount = (platformType) => {
        return adData.filter(item => item.platformType === platformType).length;
    };
    const getPlatformTotalLength = () => {
        return adData.filter(item => ['1', '2', '3', '4'].includes(item.platformType)).length;
    };

    const getSum = (eventType, channelType) => {
        return adData
            .filter(item => item.eventType === eventType && item.channelType === channelType)
            .reduce((sum, item) => sum + (item.paymentPrice || 0), 0);
    };

    const getPlatformSum = (platformType) => {
        return adData
            .filter(item => item.platformType === platformType)
            .reduce((sum, item) => sum + (item.paymentPrice || 0), 0);
    };

    const getEvent0ChannelTotal = () => {
        return ['1', '2', '3', '4', '5', '6']
            .reduce((sum, channel) => sum + getSum('0', channel), 0);
    };
    const getEvent1ChannelTotal = () => {
        return ['1', '2', '3', '4', '5', '6']
            .reduce((sum, channel) => sum + getSum('1', channel), 0);
    };
    const getEvent2ChannelTotal = () => {
        return ['1', '2', '3', '4', '5', '6']
            .reduce((sum, channel) => sum + getSum('2', channel), 0);
    };
    const getPlatformTotal = () => {
        return ['1', '2', '3', '4']
            .reduce((sum, plat) => sum + getPlatformSum(plat), 0);
    };

    const formattedStartDate = startDate.replace(/-/g, '');
    const formattedEndDate = endDate.replace(/-/g, '');

    const [stateSearch, setStateSearch] = useState({
        series: [{
            name: "Search",
            data: searchData
        }],
        options: {
            chart: {
                type: 'bar',
                toolbar: {
                    show: true
                },
            },
            plotOptions: {
                bar: {
                    borderRadius: 2,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    barHeight: '60%',
                    colors: {
                        ranges: [
                            { from: 0, to: 1000, color: '#ffea7e' },
                            { from: 1001, to: 3000, color: '#ffaf4b' },
                            { from: 3001, to: 1000000, color: '#ff7c22' },
                            { from: 3001, to: 1000000, color: '#FF4900' }
                        ],
                        backgroundBarColors: ['#eeeeee'],
                        backgroundBarOpacity: 0.6,
                    }
                },
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: ['#fff'],
                    fontSize: '14px',
                    fontWeight: 'bold',
                    fontFamily: 'NanumSquareNeo, sans-serif'
                },
            },
            xaxis: {
                categories: ['Google', 'Youtube', 'Facebook', 'Instagram', 'Naver', 'Tiktok', 'Threads', 'Twitter(X)', 'GPT', 'Gemini', 'Community'],
                labels: {
                    style: {
                        colors: ['#333'],
                        fontSize: '14px',
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        colors: ['#333'],
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'NanumSquareNeo, sans-serif'
                    },
                },
            },
            fill: {
                opacity: 1,
            },
            tooltip: {
                enabled: true,
                theme: 'dark',
                y: {
                    formatter: (value) => `${value} users`,
                }
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '16px',
                labels: {
                    colors: '#333',
                    useSeriesColors: false
                },
            },
            grid: {
                show: true,
                borderColor: '#e0e0e0',
            },
            responsive: [{
                breakpoint: 768,
                options: {
                    chart: {
                        width: '100%',
                        height: 'auto'
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    });

    const [stateSocial, setStateSocial] = useState({
        series: [{
            name: "Social",
            data: socialData
        }],
        options: {
            chart: {
                type: 'bar',
                // height: 350,
                toolbar: {
                    show: true
                },
                // background: '#f4f4f4', // 차트 배경색
            },
            plotOptions: {
                bar: {
                    borderRadius: 2,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    barHeight: '40%',
                    colors: {
                        ranges: [
                            { from: 0, to: 1000, color: '#ffea7e' },
                            { from: 1001, to: 3000, color: '#ffaf4b' },
                            { from: 3001, to: 1000000, color: '#ff7c22' },
                            { from: 3001, to: 1000000, color: '#FF4900' }
                        ],
                        backgroundBarColors: ['#eeeeee'],
                        backgroundBarOpacity: 0.6,
                    }
                },
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: ['#fff'],
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
            },
            xaxis: {
                categories: ['Google', 'Youtube', 'Facebook', 'Instagram', 'Naver', 'Tiktok', 'Threads', 'Twitter(X)', 'GPT', 'Gemini', 'Community'],
                labels: {
                    style: {
                        colors: ['#333'],
                        fontSize: '14px',
                    },
                },
                // title: {
                //     text: 'Platforms',
                //     style: {
                //         color: '#333',
                //         fontSize: '14px',
                //         fontWeight: 'bold',
                //     },
                // }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: ['#333'],
                        fontSize: '14px',
                        fontWeight: 'bold',
                    },
                },
            },
            fill: {
                opacity: 1,
            },
            tooltip: {
                enabled: true,
                theme: 'dark',
                y: {
                    formatter: (value) => `${value} users`,
                }
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '16px',
                labels: {
                    colors: '#333',
                    useSeriesColors: false
                },
            },
            grid: {
                show: true,
                borderColor: '#e0e0e0',
            },
            // colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#F86624'],
            responsive: [{
                breakpoint: 768,
                options: {
                    chart: {
                        width: '100%',
                        height: 'auto'
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        }
    });

    const [stateDevice, setStateDevice] = useState({
        series: [{
            name: "Device",
            data: deviceData
        }],
        options: {
            chart: {
                type: 'pie',
            },
            labels: ['PC', 'Mobile', 'Android', 'iOS'],
            stroke: {
                width: 3,
                colors: ['#fff'],
            },
            tooltip: {
                enabled: true,
                theme: 'dark',
                y: {
                    formatter: (value) => `${value} users`,
                },
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: ['#fff'],
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
                dropShadow: {
                    enabled: true,
                    top: 1,
                    left: 1,
                    blur: 1,
                    opacity: 0.5,
                },
            },
            legend: {
                position: 'bottom',
                fontSize: '16px',
            },
            colors: ['#ffea7e', '#ffaf4b', '#ff7c22', '#FF4900'],
            responsive: [{
                breakpoint: 768,
                options: {
                    chart: {
                        width: '100%'
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        }
    });

    useEffect(() => {
        if (startDate && endDate) {
            searchSelect();
            socialSelect();
            deviceSelect();
            selectedAllAdDataByDate();
        }
    }, [startDate, endDate])

    const searchSelect = () => {
        axios.get('/socialInit/socialData', { headers: { Authorization: LCAT }, params: { startDate: formattedStartDate, endDate: formattedEndDate } })
            .then(response => {
                const searchCounts = response.data.reduce((acc, log) => {
                    acc[log.platform] = (acc[log.platform] || 0) + 1;
                    return acc;
                }, {});

                const platforms = ['Google', 'Youtube', 'Facebook', 'Instagram', 'Naver', 'Tiktok', 'Threads', 'Twitter(X)', 'GPT', 'Gemini', 'Community'];
                const data = platforms.map(platform => searchCounts[platform] || 0);

                setSearchData(data);

                setStateSearch(prevState => ({
                    ...prevState,
                    series: [{
                        ...prevState.series[0],
                        data: data,
                    }]
                }));
            })
            .catch(error => console.error("err123: ", error));
    };

    const socialSelect = () => {
        axios.get('/socialInit/socialData', { headers: { Authorization: LCAT }, params: { startDate: formattedStartDate, endDate: formattedEndDate } })
            .then(response => {
                const socialCounts = response.data.reduce((acc, log) => {
                    acc[log.platform] = (acc[log.platform] || 0) + 1;
                    return acc;
                }, {});

                const platforms = ['Google', 'Youtube', 'Facebook', 'Instagram', 'Naver', 'Tiktok', 'Threads', 'Twitter(X)', 'GPT', 'Gemini', 'Community'];
                const data = platforms.map(platform => socialCounts[platform] || 0);

                setSocialData(data);

                setStateSocial(prevState => ({
                    ...prevState,
                    series: [{
                        ...prevState.series[0],
                        data: data,
                    }]
                }));
            })
            .catch(error => console.error("err123: ", error));
    };

    const deviceSelect = () => {
        axios.get('/init/deviceInit', {headers: { Authorization: LCAT }, params: { startDate: formattedStartDate, endDate: formattedEndDate }})
            .then(response => {
                const deviceCounts = response.data;
                // setDeviceData(deviceCounts);
                // setStateDevice(prevState => ({
                //     ...prevState,
                //     series: deviceCounts
                // }));

                // 임시데이터
                let imporaryData = [16, 16, 12, 12];
                setDeviceData(imporaryData);
                setStateDevice(prevState => ({
                    ...prevState,
                    series: imporaryData
                }));
            })
            .catch(error => console.error("err123: ", error));
    };


    return (
        <div className="AdminInflowStatusPg">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">광고분석현황</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card display-flex flex-column">
                    <div className="p-b-10 m-b-5">
                        <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle} endHandle={endHandle}/>
                    </div>
                    <div className="traffic-chart-frame display-flex flex-row just-cont-sb p-t-15 p-b-15 font-t-cont ht-450 m-b-40">
                        <div className="wd-30pc ht-auto">
                            <div className="m-b-10"><p className="font-t-title font-s-22">Traffic</p></div>
                            <ApexCharts options={stateSearch.options} series={stateSearch.series} type="bar" width={"100%"} height={"100%"} />
                        </div>
                        <div className="wd-30pc ht-auto">
                            <div className="m-b-10"><p className="font-t-title font-s-22">Purchase</p></div>
                            <ApexCharts options={stateSocial.options} series={stateSocial.series} type="bar" width={"100%"} height={"100%"} />
                        </div>
                        <div className="wd-30pc ht-auto">
                            <div className="m-b-10"><p className="font-t-title font-s-22">Device</p></div>
                            <ApexCharts options={stateDevice.options} series={stateDevice.series} type="pie" width={"100%"} height={"100%"} />
                        </div>
                    </div>

                    <div className="traffic-count-frame display-flex flex-row just-cont-sb p-b-15 font-t-cont m-t-30">
                        <div className="social-frame display-flex flex-column wd-24pc">
                            <div className="social-total-count display-flex flex-row just-cont-sb ht-10pc">
                                <p className="font-t-title font-s-19">Traffic Count</p>
                                <p className="font-t-title font-s-19">{['1', '2', '3', '4', '5', '6'].reduce((sum, ch) => sum + getCount('0', ch), 0)}</p>
                            </div>
                            <div className="social-gbn"></div>
                            <div className="social-cont-count display-flex flex-row just-cont-sb ht-90pc">
                                <div>
                                    <p>Google</p>
                                    <p>Youtube</p>
                                    <p>Facebook</p>
                                    <p>Instagram</p>
                                    <p>Naver</p>
                                    <p>Tiktok</p>
                                    <p>Threads</p>
                                    <p>Twitter(X)</p>
                                    <p>GPT</p>
                                    <p>Gemini</p>
                                    <p>Community</p>
                                </div>
                                <div>
                                    <p>{getCount('0', '1')}</p>
                                    <p>{getCount('0', '2')}</p>
                                    <p>{getCount('0', '3')}</p>
                                    <p>{getCount('0', '4')}</p>
                                    <p>{getCount('0', '5')}</p>
                                    <p>{getCount('0', '6')}</p>
                                    <p>{getCount('0', '7')}</p>
                                    <p>{getCount('0', '8')}</p>
                                    <p>{getCount('0', '9')}</p>
                                    <p>{getCount('0', '10')}</p>
                                    <p>{getCount('0', '11')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="social-frame display-flex flex-column wd-24pc">
                            <div className="social-total-count display-flex flex-row just-cont-sb ht-10pc">
                                <p className="font-t-title font-s-18">Join Count</p>
                                <p className="font-t-title font-s-17">{getEvent2ChannelTotal().toLocaleString()} / {getJoinTotalLength()}</p>
                            </div>
                            <div className="social-gbn"></div>
                            <div className="social-cont-count display-flex flex-row just-cont-sb ht-90pc">
                                <div>
                                    <p>Google</p>
                                    <p>Youtube</p>
                                    <p>Facebook</p>
                                    <p>Instagram</p>
                                    <p>Naver</p>
                                    <p>Tiktok</p>
                                    <p>Threads</p>
                                    <p>Twitter(X)</p>
                                    <p>GPT</p>
                                    <p>Gemini</p>
                                    <p>Community</p>
                                </div>
                                <div>
                                    <p>{getCount('2', '1')}</p>
                                    <p>{getCount('2', '2')}</p>
                                    <p>{getCount('2', '3')}</p>
                                    <p>{getCount('2', '4')}</p>
                                    <p>{getCount('2', '5')}</p>
                                    <p>{getCount('2', '6')}</p>
                                    <p>{getCount('2', '7')}</p>
                                    <p>{getCount('2', '8')}</p>
                                    <p>{getCount('2', '9')}</p>
                                    <p>{getCount('2', '10')}</p>
                                    <p>{getCount('2', '11')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="social-frame display-flex flex-column wd-24pc">
                            <div className="social-total-count display-flex flex-row just-cont-sb ht-10pc">
                                <p className="font-t-title font-s-18">Purchase Count</p>
                                <p className="font-t-title font-s-17">{getEvent1ChannelTotal().toLocaleString()} / {getPurchaseTotalLength()}</p>
                            </div>
                            <div className="social-gbn"></div>
                            <div className="social-cont-count display-flex flex-row just-cont-sb ht-90pc">
                                <div>
                                    <p>Google</p>
                                    <p>Youtube</p>
                                    <p>Facebook</p>
                                    <p>Instagram</p>
                                    <p>Naver</p>
                                    <p>Tiktok</p>
                                    <p>Threads</p>
                                    <p>Twitter(X)</p>
                                    <p>GPT</p>
                                    <p>Gemini</p>
                                    <p>Community</p>
                                </div>
                                <div className="text-end">
                                    <p>{getSum('1', '1').toLocaleString()} / {getCount('1', '1')}</p>
                                    <p>{getSum('1', '2').toLocaleString()} / {getCount('1', '2')}</p>
                                    <p>{getSum('1', '3').toLocaleString()} / {getCount('1', '3')}</p>
                                    <p>{getSum('1', '4').toLocaleString()} / {getCount('1', '4')}</p>
                                    <p>{getSum('1', '5').toLocaleString()} / {getCount('1', '5')}</p>
                                    <p>{getSum('1', '6').toLocaleString()} / {getCount('1', '6')}</p>
                                    <p>{getSum('1', '7').toLocaleString()} / {getCount('1', '7')}</p>
                                    <p>{getSum('1', '8').toLocaleString()} / {getCount('1', '8')}</p>
                                    <p>{getSum('1', '9').toLocaleString()} / {getCount('1', '9')}</p>
                                    <p>{getSum('1', '10').toLocaleString()} / {getCount('1', '10')}</p>
                                    <p>{getSum('1', '11').toLocaleString()} / {getCount('1', '11')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="social-frame display-flex flex-column wd-24pc">
                            <div className="social-total-count display-flex flex-row just-cont-sb ht-10pc">
                                <p className="font-t-title font-s-19">Flatform Count</p>
                                <p className="font-t-title font-s-19">{getPlatformTotalLength()}</p>
                            </div>
                            <div className="social-gbn"></div>
                            <div className="social-cont-count display-flex flex-row just-cont-sb ht-90pc">
                                <div>
                                    <p>Web(pc)</p>
                                    <p>Web(mobile)</p>
                                    <p>Android</p>
                                    <p>iOS</p>
                                </div>
                                <div>
                                    <p>{getPlatformCount('1')}</p>
                                    <p>{getPlatformCount('2')}</p>
                                    <p>{getPlatformCount('3')}</p>
                                    <p>{getPlatformCount('4')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminAdInflowPg
